import { checkoutShippingCarrierServiceStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCarrierService";

checkoutShippingCarrierServiceStyles.deliveryDatePicker = {
    hintProps: {
        color: 'black',
        italic: true,
    },
};
